var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path0, _path1, _mask, _path10, _path11, _path12, _path13, _mask2, _path14, _path15, _mask3, _path16, _path17, _mask4, _path18, _path19, _mask5, _path20, _path21, _mask6, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h900v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.47 232.015c29.05-36.667 90.78-52.007 132.047 2.958 35.005 46.621 50.255 49.288 76.86 58.158 17.568 5.859 46.315 13.798 29.564 59.145-21.924 59.351-130.386 75.383-189.69 53.229-56.711-21.183-101.502-106.955-48.781-173.49z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m461.452 142.129-9.581-9.581 9.581-9.58 9.58 9.58-9.58 9.581zm196.069 217.558-10.844-10.844L657.521 338l10.843 10.843-10.843 10.844z",
    stroke: "#E1E4E5",
    strokeWidth: 5.087,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469 411s-90-71.865-90-137.497C379 225.172 419.298 186 469 186c49.703 0 90 39.172 90 87.503C559 339.135 469 411 469 411z",
    fill: "#666AF6",
    stroke: "#666AF6",
    strokeWidth: 28.772,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M468.981 265.455c-6.004 0-10.83 4.75-10.83 10.564s4.864 10.526 10.868 10.526c6.004 0 10.83-4.712 10.83-10.564.038-5.776-4.826-10.526-10.868-10.526",
    stroke: "#fff",
    strokeWidth: 48.925,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M490.126 130.181c72.779-14.35 128.457 65.304 110.885 123.952",
    stroke: "#E1E4E5",
    strokeWidth: 1.829,
    strokeMiterlimit: 10,
    strokeDasharray: "7.6 7.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M589.985 269.962c-4.606 2.464-6.36 8.186-3.897 12.792 2.447 4.606 8.185 6.36 12.791 3.897 4.606-2.463 6.361-8.185 3.897-12.791-2.463-4.623-8.185-6.361-12.791-3.898z",
    fill: "#E1E4E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m554.305 516.533-407.355-.928a276.33 276.33 0 0 1 8.933-5.081c9.651-5.264 23.755-12.298 41.533-19.36 35.562-14.126 85.78-28.343 144.438-28.736 58.926-.396 111.864 13.342 151.181 27.56 19.653 7.107 35.89 14.329 47.759 19.957a788.724 788.724 0 0 1 13.511 6.588z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m774.99 516.533-323.074-.736c1.641-.96 3.61-2.08 5.891-3.324 7.717-4.209 18.998-9.836 33.219-15.485 28.447-11.3 68.615-22.67 115.53-22.985 47.129-.316 89.477 10.671 120.936 22.048 15.724 5.686 28.716 11.465 38.213 15.969a582.45 582.45 0 0 1 9.285 4.513zM148.577 249.581c2.814-11.405 29.403-28.061 43.612-18.02 4.361-21.727 8.441-35.276 22.69-45.98 14.249-10.703 38.024 3.288 41.843 32.591 3.818-12.046 23.232-28.281 38.828-14.591 14.43 12.667 15.877 33.893 14.37 45.98H148.577v.02zm575.81-18.033c-1.592-6.467-16.635-15.912-24.674-10.218-2.467-12.32-4.775-20.004-12.837-26.073-8.062-6.07-21.513 1.864-23.673 18.481-2.161-6.831-13.145-16.038-21.968-8.275-8.164 7.184-8.983 19.22-8.13 26.074h91.282v.011zM607 148.791c1.113-4.521 11.629-11.124 17.249-7.144 1.725-8.613 3.339-13.984 8.974-18.227 5.636-4.243 15.04 1.303 16.55 12.92 1.51-4.776 9.189-11.212 15.357-5.785 5.708 5.022 6.28 13.436 5.684 18.228H607v.008zm101 32c1.113-4.521 11.629-11.124 17.249-7.144 1.725-8.613 3.339-13.984 8.974-18.227 5.636-4.243 15.04 1.303 16.55 12.92 1.51-4.776 9.189-11.212 15.357-5.785 5.708 5.022 6.28 13.436 5.684 18.228H708v.008zm-332.452-26.468c-1.591-6.468-16.635-15.913-24.674-10.218-2.467-12.321-4.775-20.005-12.837-26.074-8.061-6.07-21.513 1.864-23.673 18.481-2.161-6.831-13.144-16.037-21.968-8.274-8.164 7.183-8.983 19.22-8.13 26.073h91.282v.012z",
    fill: "#fff",
    stroke: "#E1E4E5",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6.919,
    transform: "matrix(1 0 0 -1 329.919 280.919)",
    fill: "#E1E4E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.623,
    cy: 167.365,
    r: 7.139,
    transform: "rotate(-180 386.623 167.365)",
    fill: "#E1E4E5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M325.537 362.124c3.673 5.345 1.091 13.502 1.091 13.502s-8.535-.515-12.203-5.864c-3.673-5.346-1.095-13.499-1.095-13.499s8.535.515 12.207 5.861zm334.947-91.65c-3.67 5.343-1.09 13.495-1.09 13.495s8.53-.515 12.197-5.862c3.671-5.342 1.094-13.491 1.094-13.491s-8.53.515-12.201 5.858zM568.42 401.119c-3.671 5.343-1.091 13.495-1.091 13.495s8.53-.515 12.197-5.862c3.671-5.342 1.094-13.491 1.094-13.491s-8.53.515-12.2 5.858zm12.198-232.214c-2.779 4.045-.826 10.218-.826 10.218s6.459-.39 9.236-4.438c2.779-4.046.828-10.216.828-10.216s-6.459.39-9.238 4.436z",
    fill: "#E1E4E5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.271 472.256c0 11.337-7.448 21.531-16.635 21.531-9.188 0-16.636-10.194-16.636-21.531C186 460.92 197.437 428 202.636 428c5.198 0 16.635 32.92 16.635 44.256z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.025 442.367h-.022c-.621 0-1.123.521-1.123 1.162v61.6h2.268v-61.6c0-.641-.503-1.162-1.123-1.162z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.88 505.129h-3a3 3 0 0 0 3 3v-3zm2.268 0v3a3 3 0 0 0 3-3h-3zm-1.123-65.762h-.022v6h.022v-6zm-.022 0c-2.374 0-4.123 1.962-4.123 4.162h6c0 .917-.744 1.838-1.877 1.838v-6zm-4.123 4.162v61.6h6v-61.6h-6zm3 64.6h2.268v-6h-2.268v6zm5.268-3v-61.6h-6v61.6h6zm0-61.6c0-2.201-1.75-4.162-4.123-4.162v6a1.857 1.857 0 0 1-1.877-1.838h6z",
    fill: "#E1E4E5",
    mask: "url(#b)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.968 441.819c0 15.96-10.485 30.31-23.419 30.31-12.935 0-23.42-14.35-23.42-30.31 0-15.959 16.101-62.303 23.42-62.303 7.318 0 23.419 46.344 23.419 62.303z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M282.065 401.242h.032c.005 0 .018 0 .039.021.021.023.042.06.042.115v85.219h-.194v-85.219c0-.055.02-.092.042-.115.02-.021.033-.021.039-.021h0z",
    stroke: "#E1E4E5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.713 459.549c0 12.048-7.915 22.881-17.679 22.881s-17.679-10.833-17.679-22.881 12.155-47.033 17.679-47.033c5.525 0 17.679 34.985 17.679 47.033z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M362.448 427.785h-.024c-.659 0-1.194.553-1.194 1.235v65.464h2.411V429.02c0-.682-.534-1.235-1.193-1.235z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.23 494.484h-3a3 3 0 0 0 3 3v-3zm2.411 0v3a3 3 0 0 0 3-3h-3zm-1.193-69.699h-.024v6h.024v-6zm-.024 0c-2.413 0-4.194 1.994-4.194 4.235h6c0 .876-.712 1.765-1.806 1.765v-6zm-4.194 4.235v65.464h6V429.02h-6zm3 68.464h2.411v-6h-2.411v6zm5.411-3V429.02h-6v65.464h6zm0-65.464c0-2.241-1.781-4.235-4.193-4.235v6a1.786 1.786 0 0 1-1.807-1.765h6z",
    fill: "#E1E4E5",
    mask: "url(#c)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639 452.624c0 14.069-9.243 26.719-20.645 26.719s-20.646-12.65-20.646-26.719 14.194-54.924 20.646-54.924c6.451 0 20.645 40.855 20.645 54.924z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.838 415.53h-.028c-.77 0-1.393.646-1.393 1.443v76.446h2.815v-76.446c0-.797-.624-1.443-1.394-1.443z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M617.417 493.419h-3a3 3 0 0 0 3 3v-3zm2.815 0v3a3 3 0 0 0 3-3h-3zm-1.394-80.889h-.028v6h.028v-6zm-.028 0c-2.523 0-4.393 2.088-4.393 4.443h6c0 .761-.623 1.557-1.607 1.557v-6zm-4.393 4.443v76.446h6v-76.446h-6zm3 79.446h2.815v-6h-2.815v6zm5.815-3v-76.446h-6v76.446h6zm0-76.446c0-2.356-1.871-4.443-4.394-4.443v6a1.582 1.582 0 0 1-1.606-1.557h6z",
    fill: "#E1E4E5",
    mask: "url(#d)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M452.017 481.833c0 7.667-5.037 14.561-11.25 14.561-6.214 0-11.251-6.894-11.251-14.561s7.735-29.93 11.251-29.93c3.515 0 11.25 22.263 11.25 29.93z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.03 461.62h-.015c-.42 0-.76.351-.76.785v41.659h1.535v-41.659a.773.773 0 0 0-.76-.785z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M440.255 504.064h-3a3 3 0 0 0 3 3v-3zm1.535 0v3a3 3 0 0 0 3-3h-3zm-.76-45.444h-.015v6h.015v-6zm-.015 0c-2.173 0-3.76 1.793-3.76 3.785h6a2.227 2.227 0 0 1-2.24 2.215v-6zm-3.76 3.785v41.659h6v-41.659h-6zm3 44.659h1.535v-6h-1.535v6zm4.535-3v-41.659h-6v41.659h6zm0-41.659c0-1.993-1.588-3.785-3.76-3.785v6a2.228 2.228 0 0 1-2.24-2.215h6z",
    fill: "#E1E4E5",
    mask: "url(#e)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M552.082 473.317c0 7.667-5.037 14.561-11.251 14.561-6.213 0-11.25-6.894-11.25-14.561s7.735-29.93 11.25-29.93c3.516 0 11.251 22.263 11.251 29.93z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.095 453.103h-.016a.773.773 0 0 0-.759.786v41.659h1.534v-41.659a.773.773 0 0 0-.759-.786z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M540.32 495.548h-3a3 3 0 0 0 3 3v-3zm1.534 0v3a3 3 0 0 0 3-3h-3zm-.759-45.445h-.016v6h.016v-6zm-.016 0c-2.173 0-3.759 1.794-3.759 3.786h6a2.227 2.227 0 0 1-2.241 2.214v-6zm-3.759 3.786v41.659h6v-41.659h-6zm3 44.659h1.534v-6h-1.534v6zm4.534-3v-41.659h-6v41.659h6zm0-41.659c0-1.993-1.587-3.786-3.759-3.786v6a2.227 2.227 0 0 1-2.241-2.214h6z",
    fill: "#E1E4E5",
    mask: "url(#f)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715.675 467.793c0 11.474-7.538 21.791-16.837 21.791S682 479.267 682 467.793 693.576 423 698.838 423c5.261 0 16.837 33.319 16.837 44.793z",
    fill: "#E1E4E5",
    stroke: "#E1E4E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M699.232 437.541h-.023c-.628 0-1.137.527-1.137 1.177v62.346h2.296v-62.346c0-.65-.509-1.177-1.136-1.177z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M698.072 501.064h-3a3 3 0 0 0 3 3v-3zm2.296 0v3a3 3 0 0 0 3-3h-3zm-1.136-66.523h-.023v6h.023v-6zm-.023 0c-2.382 0-4.137 1.969-4.137 4.177h6c0 .908-.737 1.823-1.863 1.823v-6zm-4.137 4.177v62.346h6v-62.346h-6zm3 65.346h2.296v-6h-2.296v6zm5.296-3v-62.346h-6v62.346h6zm0-62.346c0-2.209-1.756-4.177-4.136-4.177v6a1.843 1.843 0 0 1-1.864-1.823h6z",
    fill: "#E1E4E5",
    mask: "url(#g)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 470.193,
    y1: 536.151,
    x2: 464.802,
    y2: -36.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.385778a2ce1794175eae43ec2a0e3b53.svg";
export { ForwardRef as ReactComponent };